module.exports = __webpack_public_path__ + "static/media/ost_11.0bae16e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_11.png
// module id = 1038
// module chunks = 0